class HardSecuredService
  constructor: ($http, $q, ConfigService, ApplicationService) ->
    @$http              = $http
    @$q                 = $q
    @ConfigService      = ConfigService
    @ApplicationService = ApplicationService

  convertApplication: ->
    deferred = @$q.defer()
    unsecured_app_id = @ApplicationService.target_application_id()
    @$http(
      method: "POST"
      url: "/apply/#{unsecured_app_id}/hard_secured_redirect"
    ).then (response) =>
      deferred.resolve response.data?.href
    , (response) ->
      deferred.reject response.data

    deferred.promise

  convertToAutoRefinanceApplication: ->
    deferred = @$q.defer()
    hs_app_id = @ApplicationService.target_application_id()
    @$http(
      method: "POST"
      url: "/apply/#{hs_app_id}/auto_refinance_redirect"
    ).then (response) =>
      deferred.resolve response.data?.href
    , (response) ->
      deferred.reject response.data

    deferred.promise

  lookupVehicle: (options) ->
    deferred = @$q.defer()

    @$http(
      method: "POST"
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/lookup_vehicle"
      data: options
    ).then (response) ->
      deferred.resolve response.data
    , (response) ->
      deferred.reject response.data

    deferred.promise

  drilldown: (options) ->
    deferred = @$q.defer()
    @$http(
      method: "POST"
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/drilldown"
      data: options
    ).then (response) ->
      deferred.resolve response.data?.data
    , (response) ->
      deferred.reject response.message

    deferred.promise

  multi_drilldown: (options) ->
    deferred = @$q.defer()
    @$http(
      method: "POST"
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/multi_drilldown"
      data: options
    ).then (response) ->
      deferred.resolve response.data?.data
    , (response) ->
      deferred.reject response.message

    deferred.promise

  insufficientCollateralReply: (reply) ->
    @$http(
      method: "POST"
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/insufficient_collateral_reply"
      data:
        response_type: reply
    )

  getAutoLenders: ->
    @$http.get "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/auto_lenders"
    .then (response) =>
      if response.data?.data and response.data.data.length > 0
        response.data.data
      else
        @$q.reject(response.data)
    , (response) =>
      @$q.reject(response.message)

angular
.module("avant.customer_applications.services")
.service "HardSecuredService", [
  "$http",
  "$q",
  "ConfigService",
  "ApplicationService",
  HardSecuredService
]


if typeof exports != 'undefined'
  if typeof module != 'undefined' && module.exports
    exports = module.exports = HardSecuredService
  exports.HardSecuredService = HardSecuredService
else
  window.HardSecuredService = HardSecuredService
